<app-page heading="Profile">
  @if (authService.currentUser | async; as user) {
    <ng-template pageTab="Account" icon="user">
      <div class="app-column gapped">
        <div class="field-grid">
            <label>Username:</label>
            <input type="text" readonly [value]="user.name">
            <label>Email:</label>
            <input type="email" readonly [value]="user.email">
        </div>

        <h3>API Keys</h3>
        <app-api-keys/>
      </div>
    </ng-template>

    <ng-template pageTab="Organizations" icon="organization">
      <div class="app-row-auto gapped">
        <app-button type="new" label="Create Organization" (clicked)="openCreateDialog()"/>
      </div>

      <div class="org-list">
        @for (org of orgService.organizations(); track org.id) {
          @if (!org.isPersonal) {
            <div class="org-card" [class.active]="org.id === orgService.activeOrganization()?.id">
              <div class="org-header">
                <div class="org-info">
                  <h3>{{ org.name }}</h3>
                  <div class="org-badges">
                    <span class="badge badge-role">{{ getRoleText(org) }}</span>
                  </div>
                </div>
                @if (org.canManageOrg) {
                  <app-button
                    type="manage"
                    [routerLink]="['/organizations', org.id]"
                    description="Manage organization"/>
                }
              </div>
              @if (org.description) {
                <p class="org-description">{{ org.description }}</p>
              }
              <div class="org-meta">
                <span class="meta-item">
                  <icon type="people"/>
                  {{ org.memberCount }} {{ org.memberCount === 1 ? 'member' : 'members' }}
                </span>
              </div>
            </div>
          }
        }
      </div>
    </ng-template>
  }
</app-page>

<!-- Create Organization Dialog -->
@if (showCreateDialog()) {
  <div class="dialog-backdrop" (click)="closeCreateDialog()">
    <div class="dialog" (click)="$event.stopPropagation()">
      <div class="dialog-header">
        <h3>Create Organization</h3>
        <button type="button" class="transparent" (click)="closeCreateDialog()" aria-label="Close">
          <icon type="close"/>
        </button>
      </div>

      <div class="dialog-body">
        <div class="field-grid">
          <label for="org-name">Organization Name *</label>
          <input
            id="org-name"
            type="text"
            [value]="newOrgName()"
            (input)="newOrgName.set($any($event.target).value)"
            placeholder="My Team"
            [disabled]="isCreating()"
            required/>

          <label for="org-description">Description (Optional)</label>
          <textarea
            id="org-description"
            [value]="newOrgDescription()"
            (input)="newOrgDescription.set($any($event.target).value)"
            placeholder="A brief description of this organization"
            [disabled]="isCreating()"
            rows="3"></textarea>
        </div>
      </div>

      <div class="dialog-footer">
        <app-button type="cancel" (clicked)="closeCreateDialog()" [disabled]="isCreating()"/>
        <app-button type="save" label="Create" (clicked)="createOrganization()"
                    [disabled]="isCreating() || !newOrgName().trim()"/>
      </div>
    </div>
  </div>
}
